import {createContext} from "react";

type TableContextType = {
    size: "sm" | "md";
    gridTemplateColumnsClass?: string;
};

export const TableContext = createContext<TableContextType>({size: "md"});

export const TableHeaderFooterContext = createContext<{
    type?: "footer" | "header";
}>({
    type: undefined
});
